import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerRootService } from '@se/se.ui.html5';
import { isEmpty, partition } from 'lodash-es';
import { forkJoin, map, Observable, of } from 'rxjs';

export interface DeleteExamData {
    id: string;
    isReported: boolean;
}

export interface DeleteExamsResult {
    succeeded: string[];
    failed: string[];
}

export interface IDeleteExamsParams {
    idExaminations: string[];
    idDeletingReason?: string; //dipende da RadioSettingsService.isDeletingReasonEnabled();
}

@Injectable({
    providedIn: 'root',
})
export class WorkflowHttpService {
    constructor(
        private http: HttpClient,
        private serverRoot: ServerRootService,
    ) {}

    deleteExam(exam: DeleteExamData, idDeletingReason: string | null) {
        const deleteRestPath = exam.isReported
            ? '/Workflow/DeleteReportedExaminations'
            : '/Workflow/DeleteExaminations';
        return this.http.put<boolean>(
            `${this.serverRoot.getServerRoot()}${deleteRestPath}`,
            {
                idExaminations: [exam.id],
                idDeletingReason,
            }, //IDeleteExamsParams
            this.serverRoot.buildOptions(),
        );
    }

    deleteEcgs(exams: DeleteExamData[]): Observable<DeleteExamsResult> {
        // Dividi gli esami per refertati e non, ed effettua due chiamate REST diverse a seconda dello stato.
        const [reported, executed] = partition(exams, 'isReported').map((exams) => exams.map((exam) => exam.id));
        const hasToDeleteReported = !isEmpty(reported);
        const hasToDeleteExecuted = !isEmpty(executed);
        const httpCalls: Observable<boolean>[] = [];
        if (hasToDeleteReported) {
            httpCalls.push(
                this.http.put<boolean>(
                    this.serverRoot.getServerRoot() + '/Workflow/DeleteReportedExaminations',
                    {
                        idExaminations: reported,
                        idDeletingReason: null,
                    },
                    this.serverRoot.buildOptions(),
                ),
            );
        } else {
            httpCalls.push(of(true));
        }
        if (hasToDeleteExecuted) {
            httpCalls.push(
                this.http.put<boolean>(
                    this.serverRoot.getServerRoot() + '/Workflow/DeleteExaminations',
                    {
                        idExaminations: executed,
                        idDeletingReason: null,
                    },
                    this.serverRoot.buildOptions(),
                ),
            );
        } else {
            httpCalls.push(of(true));
        }

        return forkJoin(httpCalls).pipe(
            map(([reportedSucceeded, executedSucceeded]) => {
                // Le due chiamate falliscono o riescono in blocco per tutti gli esami passati ad ognuna.
                const succeeded: string[] = [];
                const failed: string[] = [];

                if (reportedSucceeded) {
                    succeeded.push(...reported);
                } else {
                    failed.push(...reported);
                }
                if (executedSucceeded) {
                    succeeded.push(...executed);
                } else {
                    failed.push(...executed);
                }

                return { succeeded, failed };
            }),
        );
    }

    deleteExams(exams: DeleteExamData[]): Observable<DeleteExamsResult> {
        // Dividi gli esami per refertati e non, ed effettua due chiamate REST diverse a seconda dello stato.
        const [reported, executed] = partition(exams, 'isReported').map((exams) => exams.map((exam) => exam.id));
        const hasToDeleteReported = !isEmpty(reported);
        const hasToDeleteExecuted = !isEmpty(executed);
        const httpCalls: Observable<boolean>[] = [];
        if (hasToDeleteReported) {
            httpCalls.push(
                this.http.put<boolean>(
                    this.serverRoot.getServerRoot() + '/Workflow/DeleteReportedExaminations',
                    reported,
                    this.serverRoot.buildOptions(),
                ),
            );
        } else {
            httpCalls.push(of(true));
        }
        if (hasToDeleteExecuted) {
            httpCalls.push(
                this.http.put<boolean>(
                    this.serverRoot.getServerRoot() + '/Workflow/DeleteExaminations',
                    executed,
                    this.serverRoot.buildOptions(),
                ),
            );
        } else {
            httpCalls.push(of(true));
        }

        return forkJoin(httpCalls).pipe(
            map(([reportedSucceeded, executedSucceeded]) => {
                // Le due chiamate falliscono o riescono in blocco per tutti gli esami passati ad ognuna.
                const succeeded: string[] = [];
                const failed: string[] = [];

                if (reportedSucceeded) {
                    succeeded.push(...reported);
                } else {
                    failed.push(...reported);
                }
                if (executedSucceeded) {
                    succeeded.push(...executed);
                } else {
                    failed.push(...executed);
                }

                return { succeeded, failed };
            }),
        );
    }
}


